import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useRef, useEffect } from 'react';
import { useButton, useFocused } from '@indriver/nova-core';
import { Box, Notification, LabelBox, PrefixPostfix, Label, LoadingBox } from './button.styles.js';
import { Loader } from '../loader/loader.js';

var _excluded = ["children", "type", "design", "size", "dir", "prefix", "postfix", "loadingTitle", "disabled", "handleFocus", "onBlur", "onKeyUp", "loading", "isLoading", "handleClick", "handleKeyDown", "notification"];

var _LOADER_DESIGN;
var LOADER_SIZE = {
  xs: 'm',
  s: 'm',
  m: 'm',
  l: 'm'
};
var LOADER_DESIGN = (_LOADER_DESIGN = {
  primary: 'onbrand',
  secondary: 'primary',
  tertiary: 'primary'
}, _LOADER_DESIGN['error-low'] = 'error', _LOADER_DESIGN['error-high'] = 'white', _LOADER_DESIGN.ghost = 'primary', _LOADER_DESIGN['tertiary-inverse'] = 'oncolor', _LOADER_DESIGN);
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useButton = useButton(props),
      children = _useButton.children,
      _useButton$type = _useButton.type,
      type = _useButton$type === void 0 ? 'button' : _useButton$type,
      _useButton$design = _useButton.design,
      design = _useButton$design === void 0 ? 'primary' : _useButton$design,
      _useButton$size = _useButton.size,
      size = _useButton$size === void 0 ? 'm' : _useButton$size,
      _useButton$dir = _useButton.dir,
      dir = _useButton$dir === void 0 ? 'ltr' : _useButton$dir,
      prefix = _useButton.prefix,
      postfix = _useButton.postfix,
      loadingTitle = _useButton.loadingTitle,
      _useButton$disabled = _useButton.disabled,
      disabled = _useButton$disabled === void 0 ? false : _useButton$disabled,
      handleFocus = _useButton.handleFocus,
      onBlur = _useButton.onBlur,
      onKeyUp = _useButton.onKeyUp;
      _useButton.loading;
      var isLoading = _useButton.isLoading,
      handleClick = _useButton.handleClick,
      handleKeyDown = _useButton.handleKeyDown,
      notification = _useButton.notification,
      attrs = _objectWithoutPropertiesLoose(_useButton, _excluded);

  var _useFocused = useFocused({
    onKeyUp: onKeyUp,
    onBlur: onBlur
  }),
      focused = _useFocused.focused,
      handleBlur = _useFocused.handleBlur,
      handleKeyUp = _useFocused.handleKeyUp;

  var btnRef = useRef(null);
  useEffect(function () {
    if (!ref) {
      return;
    }

    if (typeof ref === 'function') {
      ref(btnRef.current);
    } else {
      // @ts-ignore:next-line
      ref.current = btnRef.current;
    }
  }, [ref]);

  var getNodeType = function getNodeType(node) {
    var _node$type, _node$type2;

    return node && String(((_node$type = node.type) == null ? void 0 : _node$type.displayName) || ((_node$type2 = node.type) == null ? void 0 : _node$type2.name));
  };

  return /*#__PURE__*/React__default.createElement(Box, _extends({
    design: design,
    focused: focused,
    size: size,
    type: type,
    disabledView: disabled,
    loadingView: isLoading,
    "aria-disabled": disabled,
    "aria-busy": isLoading,
    "aria-live": isLoading ? 'polite' : 'off',
    square: !children
  }, attrs, {
    ref: btnRef,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onKeyUp: handleKeyUp
  }), notification && /*#__PURE__*/React__default.createElement(Notification, {
    type: getNodeType(notification),
    size: size,
    dir: dir
  }, notification), /*#__PURE__*/React__default.createElement(LabelBox, {
    disabled: disabled,
    loadingView: isLoading,
    dir: dir,
    size: size,
    "aria-hidden": isLoading
  }, prefix && /*#__PURE__*/React__default.createElement(PrefixPostfix, {
    dir: dir,
    disabledView: disabled,
    design: design,
    size: size
  }, prefix), children && /*#__PURE__*/React__default.createElement(Label, null, children), postfix && /*#__PURE__*/React__default.createElement(PrefixPostfix, {
    dir: dir,
    disabledView: disabled,
    design: design,
    size: size
  }, postfix)), isLoading && /*#__PURE__*/React__default.createElement(LoadingBox, {
    dir: dir,
    size: size
  }, /*#__PURE__*/React__default.createElement(PrefixPostfix, {
    dir: dir,
    size: size,
    design: design
  }, /*#__PURE__*/React__default.createElement(Loader, {
    design: LOADER_DESIGN[design],
    size: LOADER_SIZE[size]
  })), loadingTitle && /*#__PURE__*/React__default.createElement(Label, null, loadingTitle, "...")));
});

export { Button };
